import Ajax from 'global/od/Ajax';

const { events } = window.od;

export default class VariantZone {
	constructor(zoneElement) {
		this.element = zoneElement;
		this.placementId = this.element.getAttribute('data-product-variant-zone');
		this.currentLegacySku = this.element.getAttribute(
			'data-current-legacy-sku',
		);
		this.variantGroups = [];
	}

	// Keep here at least until code is stable to help with debugging/handover
	// addResults(zoneResult) {
	// 	this.variantGroups = [
	// 		{
	// 			type: 'colour',
	// 			variants: [
	// 				{
	// 					sku: '4020399',
	// 					text: 'Black',
	// 					url: '/nl/x-p-4020399',
	// 				},
	// 				{
	// 					sku: 'ED751-WI',
	// 					text: 'White',
	// 					url: '/nl/x-p-ED751-WI',
	// 				},
	// 				{
	// 					sku: '4677741',
	// 					text: 'Red',
	// 					url: '/nl/x-p-4677741',
	// 				},
	// 				{
	// 					sku: '3372984',
	// 					text: 'Blue',
	// 					url: '/nl/x-p-3372984',
	// 				},
	// 				{
	// 					sku: '4601691',
	// 					text: 'Green',
	// 					url: '/nl/x-p-4601691',
	// 				},
	// 			],
	// 		},
	// 	];
	// }
	addResults(zoneResult) {
		this.variantGroups = zoneResult.variantGroups;
	}

	requestRender() {
		return this.requestTemplate()
			.then(response => {
				this.render(response.data);
				return this;
			})
			.catch(() => this);
	}

	requestTemplate() {
		const variantGroups = this.variantGroups.map(group => ({
			type: group.type,
			productIds: group.variants
				.filter(variant => variant?.sku)
				.map(variant => variant.sku),
		}));

		return Ajax({
			method: 'POST',
			url: '/ajax/bundle/variants',
			contentType: 'application/json',
			dataType: 'html',
			data: JSON.stringify({ variantGroups }),
			Accept: 'text/html',
		});
	}

	render(renderedHtml) {
		this.element.innerHTML = renderedHtml;

		const renderedGroups = this.element.querySelectorAll('[data-variant-type]');

		this.variantGroups.forEach(group => {
			const groupElement = Array.from(renderedGroups).find(
				element => element.getAttribute('data-variant-type') === group.type,
			);

			if (!groupElement) return;

			const renderedVariants =
				groupElement.querySelectorAll('[data-legacy-sku]');

			group.variants.forEach(variant => {
				const variantElement = Array.from(renderedVariants).find(
					element => element.getAttribute('data-legacy-sku') === variant.sku,
				);

				if (!variantElement) return;

				const isSelected = variant.sku === this.currentLegacySku;
				const link = variantElement.querySelector(
					'.product-variant-zone__link',
				);

				variantElement.classList.toggle(
					'product-variant-zone__variant--selected',
					isSelected,
				);

				if (link) {
					if (isSelected) {
						link.setAttribute('aria-current', 'page');
						link.removeAttribute('href');
					} else {
						link.removeAttribute('aria-current');

						if (variant.url) {
							link.setAttribute('href', variant.url);
						}
					}
				}

				const textElement = variantElement.querySelector(
					'.product-variant-zone__label',
				);

				if (textElement) {
					textElement.textContent = variant.text;
				}
			});
		});

		events.publish('richRelevanceVariants_Loaded', {
			placementId: this.placementId,
			variantGroups: this.variantGroups,
			element: this.element,
		});
	}
}
